import { render, staticRenderFns } from "./FaqCategoryComponent.vue?vue&type=template&id=82e432ac&"
import script from "./FaqCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports